"use client";
import type { Typography } from "./typography";

export function OptionsCss({ typography }: { typography: Typography }) {
  return <style jsx global>
    {`
          @media (min-width: 768px) {
            h1 {
              font-size: ${typography.h1_desktop}!important;
            }

            h2 {
              font-size: ${typography.h2_desktop}!important;
            }

            h3 {
              font-size: ${typography.h3_desktop}!important;
            }

            h4 {
              font-size: ${typography.h4_desktop}!important;
            }

            h5 {
              font-size: ${typography.h5_desktop}!important;
            }

            h6 {
              font-size: ${typography.h6_desktop}!important;
            }
          }

          h1 {
            font-size: ${typography.h1_mobile}!important;
            font-weight: 600;
            line-height: 1.1;
            text-align: left;
          }

          h2 {
            font-size: ${typography.h2_mobile}!important;
            font-weight: 600;
            line-height: 1.1;
            text-align: left;
          }

          h3 {
            font-size: ${typography.h3_mobile}!important;
            font-weight: 600;
            line-height: 1.1;
            text-align: left;
          }

          h4 {
            font-size: ${typography.h4_mobile}!important;
            font-weight: 600;
            line-height: 1.1;
            text-align: left;
          }

          h5 {
            font-size: ${typography.h5_mobile}!important;
            font-weight: 600;
            line-height: 1.1;
            text-align: left;
          }

          h6 {
            font-size: ${typography.h6_mobile}!important;
            font-weight: 600;
            line-height: 1.1;
            text-align: left;
          }
        `}
  </style>
}
